import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { media } from '@caldera-digital/theme';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  box-sizing: initial;\n  left: 0;\n  top: 0;\n  margin: 0;\n  width: 18px;\n  height: 18px;\n  padding: 3px;\n  text-align: center;\n  cursor: pointer;\n  transition: opacity 250ms ease;\n  display: none;\n\n  ", ";\n\n  > div {\n    position: relative;\n    background-color: ", ";\n    width: 20px;\n    height: 3px;\n    border-width: 1px 0;\n    margin: 0 auto 3px;\n    padding: 0;\n    border-radius: 1px;\n    font-size: 1px;\n    transition: all 200ms ease;\n    transform-origin: 0 0;\n\n    &:last-child {\n      margin: 0;\n    }\n  }\n\n  &[open] {\n    ", " {\n      transform: translate(4px, -1px) rotate(45deg);\n    }\n\n    ", " {\n      opacity: 0;\n    }\n\n    ", " {\n      transform: translate(2px, 1px) rotate(-45deg);\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Hb1 = styled.div(_templateObject());
var Hb2 = styled.div(_templateObject2());
var Hb3 = styled.div(_templateObject3());
var HamburgerWrapper = styled.div(_templateObject4(), media.forSmallOnly(_templateObject5()), function (props) {
  return props.hamburgerColor || props.theme.white;
}, Hb1, Hb2, Hb3);

var Hamburger = function Hamburger(props) {
  return React.createElement(HamburgerWrapper, Object.assign({
    open: props.open
  }, props), React.createElement(Hb1, null), React.createElement(Hb2, null), React.createElement(Hb3, null));
};

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    position: absolute;\n    height: calc(100vh - ", ");\n    top: ", ";\n    left: 0;\n    background-color: ", ";\n    width: 100%;\n    display: ", ";\n    flex-direction: column;\n    padding: 1rem;\n    z-index: 20;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n    color: ", " !important;\n    margin-bottom: 0.25rem;\n    padding: .75rem;\n    margin: 0;\n    font-size: ", ";\n\n      &.selected {\n        font-weight: bold;\n      }\n\n      &:after {\n        display: none !important;\n      }\n  "]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n  color: ", " !important;\n  text-decoration: none;\n  margin-right: 1rem;\n  position: relative;\n  cursor: pointer;\n\n  &:last-child {\n    margin-right: 0;\n  }\n\n  /* &:before, */\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: -7px;\n    width: 0px;\n    height: 3px;\n    margin: 5px 0 0;\n    transition: all 0.4s ease-in-out;\n    opacity: 0;\n    left: 0;\n  }\n\n  &:hover {\n    &:after {\n      opacity: 1;\n      background-color: ", ";\n      width: 100%;\n    }\n  }\n\n  &.selected {\n    &:after {\n      opacity: 1;\n      background-color: ", ";\n      width: 100%;\n    }\n  }\n\n  ", "\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n    height: ", ";\n    padding: 0 1rem;\n  "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 2rem;\n  position: relative;\n  z-index: 100;\n\n  ", "\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var NavContainer = styled.div(_templateObject$1(), function (props) {
  return props.theme.desktopHeaderHeight;
}, function (props) {
  return props.theme.primaryColor;
}, function (props) {
  return props.theme.white;
}, media.forSmallOnly(_templateObject2$1(), function (props) {
  return props.theme.mobileHeaderHeight;
}));
var NavOptionsContainer = styled.div(_templateObject3$1());
var NavLinkStyles = css(_templateObject4$1(), function (props) {
  return props.theme.white;
}, function (props) {
  return props.theme.white;
}, function (props) {
  return props.theme.white;
}, media.forSmallOnly(_templateObject5$1(), function (props) {
  return props.theme.defaultFontColor;
}, function (props) {
  return props.theme.defaultFontSize;
}));
var RoutesContainer = styled.div(_templateObject6(), media.forSmallOnly(_templateObject7(), function (_ref) {
  var theme = _ref.theme;
  return theme.mobileHeaderHeight;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.mobileHeaderHeight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.white;
}, function (_ref4) {
  var open = _ref4.open;
  return open ? 'flex' : 'none';
}));

var createRouteLink = function createRouteLink(as) {
  return styled(as)(_templateObject8(), NavLinkStyles);
};

var NavComponent = function NavComponent(_ref5) {
  var _ref5$routes = _ref5.routes,
      routes = _ref5$routes === void 0 ? [] : _ref5$routes,
      _ref5$className = _ref5.className,
      className = _ref5$className === void 0 ? '' : _ref5$className,
      _ref5$containerStyle = _ref5.containerStyle,
      containerStyle = _ref5$containerStyle === void 0 ? {} : _ref5$containerStyle,
      _ref5$navOptionsStyle = _ref5.navOptionsStyle,
      navOptionsStyle = _ref5$navOptionsStyle === void 0 ? {} : _ref5$navOptionsStyle,
      _ref5$hamburgerStyle = _ref5.hamburgerStyle,
      hamburgerStyle = _ref5$hamburgerStyle === void 0 ? {} : _ref5$hamburgerStyle,
      _ref5$renderLeftSecti = _ref5.renderLeftSection,
      renderLeftSection = _ref5$renderLeftSecti === void 0 ? function () {
    return null;
  } : _ref5$renderLeftSecti,
      _ref5$hamburgerOpen = _ref5.hamburgerOpen,
      hamburgerOpenProp = _ref5$hamburgerOpen === void 0 ? false : _ref5$hamburgerOpen,
      onHamburgerClicked = _ref5.onHamburgerClicked,
      hamburgerColor = _ref5.hamburgerColor;

  var _React$useState = React.useState(hamburgerOpenProp),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      hamburgerOpen = _React$useState2[0],
      setHamburgerOpen = _React$useState2[1];

  useEffect(function () {
    setHamburgerOpen(hamburgerOpenProp);
  }, [hamburgerOpenProp]);
  return React.createElement(NavContainer, {
    className: className,
    style: containerStyle
  }, renderLeftSection(), React.createElement(NavOptionsContainer, {
    style: navOptionsStyle
  }, React.createElement(Hamburger, {
    open: hamburgerOpen,
    onClick: function onClick() {
      return onHamburgerClicked ? onHamburgerClicked(hamburgerOpen) : setHamburgerOpen(!hamburgerOpen);
    },
    hamburgerColor: hamburgerColor,
    style: hamburgerStyle
  }), React.createElement(RoutesContainer, {
    open: hamburgerOpen
  }, routes.map(function (_ref6) {
    var route = _ref6.route,
        text = _ref6.text,
        _ref6$as = _ref6.as,
        as = _ref6$as === void 0 ? 'a' : _ref6$as,
        _ref6$selected = _ref6.selected,
        selected = _ref6$selected === void 0 ? false : _ref6$selected,
        renderLinkContent = _ref6.renderLinkContent,
        _ref6$onClick = _ref6.onClick,
        _onClick = _ref6$onClick === void 0 ? function () {
      return null;
    } : _ref6$onClick,
        _ref6$className = _ref6.className,
        className = _ref6$className === void 0 ? '' : _ref6$className,
        rest = _objectWithoutProperties(_ref6, ["route", "text", "as", "selected", "renderLinkContent", "onClick", "className"]); // The controls what the link renders as so it works with Reach, React Router, and normal


    var RouteLink = createRouteLink(as);
    return React.createElement(RouteLink, Object.assign({
      to: route,
      key: route,
      className: "".concat(className, " ").concat(selected ? 'selected' : ''),
      onClick: function onClick() {
        setHamburgerOpen(false);

        _onClick(_objectSpread({
          route: route,
          text: text
        }, rest));
      }
    }, rest), renderLinkContent ? renderLinkContent() : text);
  }))));
};

var Nav = function Nav(props) {
  return React.createElement(NavComponent, props);
};

export { Hamburger, Nav, NavComponent };